import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'
import {runIfExist} from "@/utils/function";


export const uploadFiles = createAsyncThunk('file/upload',
	async ({ formData, callback }: any) => {
		const url = 'v1/files'
		const config = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		}
		const response: AxiosResponse<FileUrlResponse> = await instance.post(url, formData, config)
		runIfExist(callback, response.data)
		return response.data
	})
